import { convertToExportedView } from '@estee/elc-service';
import { SMARTGIFT } from '@estee/elc-service-view-names';
import { ISmartGift } from './SmartGift';
import serviceNames from '~setup/SmartgiftService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<ISmartGift>(
    () => import('./SmartGift'),
    SMARTGIFT,
    serviceNames.smartGiftViewController
);
